var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#6C6C6C"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data-refresh_svg__clip0_773_1592)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.173 2.57a.75.75 0 01.816-.677c4.37.405 7.801 4.074 7.801 8.557a8.605 8.605 0 01-4.195 7.384.75.75 0 01-.77-1.288 7.105 7.105 0 003.465-6.096c0-3.698-2.83-6.729-6.44-7.063a.75.75 0 01-.677-.816z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81 5.41c.07.09.19.1.28.03l.21-.17c.09-.07.1-.19.03-.28L8.55 2.72a.2.2 0 01.05-.29L10.99.82c.09-.06.12-.19.05-.28l-.15-.22a.196.196 0 00-.28-.05L7.63 2.28a.2.2 0 00-.05.29L9.8 5.4l.01.01z",
    stroke: "#6C6C6C",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.224 3.305a.75.75 0 01-.259 1.029A7.105 7.105 0 001.5 10.43a7.09 7.09 0 006.437 7.063.75.75 0 11-.134 1.494A8.59 8.59 0 010 10.43a8.605 8.605 0 014.195-7.384.75.75 0 011.029.259z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24 15.43c-.07-.09-.19-.1-.28-.03l-.21.16c-.09.07-.1.19-.04.28l1.91 2.43L6.05 20c-.09.06-.12.19-.05.28l.15.22c.06.09.19.12.28.05l2.98-2.01a.2.2 0 00.05-.29l-2.22-2.83v.01z",
    stroke: "#6C6C6C",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "data-refresh_svg__clip0_773_1592"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16.78v20.85H0z"
  })))));
}
export default SvgDataRefresh;